<template>
  <div class="container-fluid" style="overflow-y: hidden">
    <div class ="row" style="align-items: center; justify-content: center; gap: 30px;">
      <div v-for="(fuelTank) in fuelTanksFiltered" :key="fuelTank">
          <b-card no-body :header="displayHeader(fuelTank)" class="overflow-hidden" style="max-width: 740px;">
            <b-row no-gutters>
              <b-col md="4">
                <progress-bar :options="calculateProgressBarOptions(fuelTank)" :value="calculateFuelVolume(fuelTank)" style="width:300px; padding-left: 20px; padding-top: 50%;"/>
              </b-col>
              <b-col md="8">
                <b-card-body>
                  <b-card-title style="font-size: 14px;">{{fuelTank.fuelTankName}}</b-card-title>
                  <b-card-text>
                    <b-table
                      small
                      hover
                      bordered
                      responsive
                      :fields = "headers"
                      :items = "displayFuelTankData(fuelTank)"
                      stacked
                    >
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
    </div>
  </div>
</template>

<script>

import {
  roleService,
  utilsService,
  userService
} from "../../../services";

import ProgressBar from 'vuejs-progress-bar'

export default {
  name: "FuelTanksDashboard",
  components: {
    ProgressBar
  },
  props: {
    fuelTanksInfo: Array,
    fuelTanks: Array,
  },
  data() {
    return {
      FUEL_TANKS_INFO_EXPORT_ROLE: roleService.FUEL_TANKS_INFO_EXPORT_ROLE
    };
  },
  computed: {
    fuelTanksFiltered() {
      const fuelTanksFiltered = [];

      if (this.fuelTanks && this.fuelTanksInfo) {
        for (let i = 0; i < this.fuelTanks.length; i++) {
          for (let j = 0; j < this.fuelTanksInfo.length; j++) {
            if (this.fuelTanks[i].vehicleId != this.fuelTanksInfo[j].vehicleId) {
              continue;
            }

            const fuelTankInfo = this.fuelTanksInfo[j].fuelTanks.find((item) => {
              return item.fuelTankId == this.fuelTanks[i].fuelTankId;
            });

            if (fuelTankInfo) {
              fuelTanksFiltered.push({
                companyName: this.fuelTanks[i].companyName,
                depoName: this.fuelTanks[i].depoName,
                fuelTankName: this.fuelTanks[i].fuelTankName,
                fuelType: this.fuelTanks[i].fuelType,
                time: fuelTankInfo.time,
                fuelVolumeTotal: fuelTankInfo.fuelVolumeTotal,
                fuelVolume: fuelTankInfo.fuelVolume,
                fuelVolume15: fuelTankInfo.fuelVolume15,
                fuelVolumeFree: fuelTankInfo.fuelVolumeFree,
                fuelVolumePercent: fuelTankInfo.fuelVolumePercent,
                fuelLevel: fuelTankInfo.fuelLevel,
                fuelWeight: fuelTankInfo.fuelWeight,
                fuelTemperature: fuelTankInfo.fuelTemperature,
                fuelDensity: fuelTankInfo.fuelDensity,
                waterVolume: fuelTankInfo.waterVolume,
                waterLevel: fuelTankInfo.waterLevel
              });
            }
          }
        }
      }

      return fuelTanksFiltered;
    },
    headers() {
      const filteredColumns = ["companyName", "depoName", "fuelTankName"];
      const headers = [];
      const disabledHeadersByDefault = ["waterVolume", "waterLevel"];

      const displayedColumnsSetting =
        this.$store.state.authentication.userSettings.find((x) => {
          return (
            x.settingName == userService.FUEL_TANKS_TABLE_DISPLAYED_COLUMNS
          );
        });

      if (displayedColumnsSetting) {
        const displayedColumns =
          displayedColumnsSetting.settingValue.split(",");

        for (let i = 0; i < displayedColumns.length; i++) {
          if (filteredColumns.includes(displayedColumns[i])) {
            continue;
          }

          headers.push({
            key: displayedColumns[i],
            label:
              this.$store.state.localization.data.mainPage.fuelTanks
                .tableColumns[displayedColumns[i]],
          });
        }
      } else {
        for (let key in this.$store.state.localization.data.mainPage.fuelTanks
          .tableColumns) {
          if (filteredColumns.includes(key) || disabledHeadersByDefault.includes(key)) {
            continue;
          }
          headers.push({
            key: key,
            label:
              this.$store.state.localization.data.mainPage.fuelTanks
                .tableColumns[key],
          });
        }
      }

      return headers;
    },
  },
  methods: {
    displayHeader(fuelTank) {
      return `${this.$store.state.localization.data.mainPage.fuelTanks.tableColumns.depoName}: ${fuelTank.depoName}`
    },
    displayFuelTankData(fuelTank) {
      return [
        {
          time: utilsService.formatDateTime(new Date(fuelTank.time * 1000), utilsService.DATE_TIME_FORMAT),
          fuelType: fuelTank.fuelType,
          fuelVolume: utilsService.formatNumber(fuelTank.fuelVolume, 3),
          fuelVolumeTotal: utilsService.formatNumber(fuelTank.fuelVolumeTotal, 3),
          fuelVolume15: utilsService.formatNumber(fuelTank.fuelVolume15, 3),
          fuelVolumeFree: utilsService.formatNumber(fuelTank.fuelVolumeFree, 3),
          fuelVolumePercent: utilsService.formatNumber(fuelTank.fuelVolumePercent, 2),
          fuelLevel: utilsService.formatNumber(fuelTank.fuelLevel / 10, 1),
          fuelWeight: utilsService.formatNumber(fuelTank.fuelWeight, 3),
          fuelTemperature: utilsService.formatNumber(fuelTank.fuelTemperature, 2),
          fuelDensity: utilsService.formatNumber(fuelTank.fuelDensity, 4),
          waterVolume: utilsService.formatNumber(fuelTank.waterVolume, 3),
          waterLevel: utilsService.formatNumber(fuelTank.waterLevel / 10, 1),
        }
      ]
    },
    calculateFuelVolume(fuelTank) {
      return parseFloat(fuelTank.fuelVolumePercent.toFixed(2));
    },
    calculateProgressBarOptions(fuelTank) {
      const options = {
        text: {
            color: '#FFFFFF',
            shadowEnable: true,
            shadowColor: '#000000',
            fontSize: 14,
            fontFamily: 'Helvetica',
            dynamicPosition: false,
            hideText: false
          },
          progress: {
            backgroundColor: '#333333',
            inverted: false,
          },
          layout: {
            height: 100,
            width: 100,
            verticalTextAlign: 50,
            horizontalTextAlign: 40,
            zeroOffset: 0,
            strokeWidth: 30,
            progressPadding: 0,
            type: 'cylinder'
          }
      };

      if (fuelTank.fuelVolumePercent < 10) {
        options.progress.color = "#ff1a1a";
      } else if (fuelTank.fuelVolumePercent > 10 && fuelTank.fuelVolumePercent < 30) {
        options.progress.color = "#ffad33";
      }
      else {
        options.progress.color = "#2dbd2d";
      }

      return options;
    }
  },
};
</script>
<style>
.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
  text-align: left !important;
  width: 55% !important;
}

.table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
  width: calc(100% - 55%) !important;
}

</style>